import { AgentConfigData, AgentInstructionOptionId } from "@jugl-web/rest-api";
import { DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION } from "@web-src/modules/cx/pages/CXAIAgentsPage/consts";

export const CUSTOM_PROMPT_ID: AgentInstructionOptionId = "custom-prompt";

const INSTRUCTION_OPTION_IDS = Object.keys(
  DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION
) as AgentInstructionOptionId[];

export const isInstructionOptionId = (
  value: string | null | undefined
): value is AgentInstructionOptionId =>
  typeof value === "string" &&
  INSTRUCTION_OPTION_IDS.includes(value as AgentInstructionOptionId);

export const getDefaultInstructionItem = (
  optionId: AgentInstructionOptionId
): AgentConfigData["saved_instructions"][number] => ({
  name: optionId,
  value: DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION[optionId],
});

export const normalizeInstructionItems = (
  items?: AgentConfigData["saved_instructions"]
): AgentConfigData["saved_instructions"] => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return [{ name: CUSTOM_PROMPT_ID, value: "" }];
  }

  const deduped = items.reduce<AgentConfigData["saved_instructions"]>(
    (acc, item) => {
      if (!INSTRUCTION_OPTION_IDS.includes(item.name)) return acc;
      if (acc.some((existingItem) => existingItem.name === item.name))
        return acc;

      acc.push({
        name: item.name,
        value: typeof item.value === "string" ? item.value : "",
      });
      return acc;
    },
    []
  );

  if (deduped.length === 0) {
    return [{ name: CUSTOM_PROMPT_ID, value: "" }];
  }

  return deduped;
};

export const upsertInstructionItem = (
  items: AgentConfigData["saved_instructions"] | undefined,
  optionId: AgentInstructionOptionId,
  valueOverride?: string
): AgentConfigData["saved_instructions"] => {
  const normalized = normalizeInstructionItems(items);
  const existingIndex = normalized.findIndex((item) => item.name === optionId);

  if (existingIndex !== -1) {
    return normalized.map((item, index) =>
      index === existingIndex
        ? { ...item, value: valueOverride ?? item.value }
        : item
    );
  }

  return [
    ...normalized,
    {
      ...getDefaultInstructionItem(optionId),
      value: valueOverride ?? DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION[optionId],
    },
  ];
};
